<h2 mat-dialog-title>
    <span>
        {{ firstStep ? data.cropOptions.title : data.avatarOptions.title }}
    </span>
</h2>
<mat-dialog-content>
    <ng-container *ngIf="firstStep">
        <div class="flex gap-4 items-start justify-between mb-4">
            <div class="grow text-sm text-secondary leading-4">
                {{ data.cropOptions.description }}
            </div>
            <div class="flex-none" *ngIf="firstStep">
                <fui-button
                    type="button-icon"
                    [title]="appService.language_dictionary.files_crop_rotate"
                    color="flat"
                    icon="rotate-right"
                    height="mini"
                    (clickEvent)="rotateImage()"
                >
                </fui-button>
            </div>
        </div>

        <div>
            <image-cropper
                [imageBase64]="data.data"
                [maintainAspectRatio]="data.cropOptions.maintainAspectRatio"
                [aspectRatio]="data.cropOptions.aspectRatio"
                [resizeToWidth]="data.cropOptions.resizeToWidth"
                [resizeToHeight]="data.cropOptions.resizeToHeight"
                [cropperMinWidth]="data.cropOptions.cropperMinWidth"
                [cropperMinHeight]="data.cropOptions.cropperMinHeight"
                [cropperMaxWidth]="data.cropOptions.cropperMaxWidth"
                [cropperMaxHeight]="data.cropOptions.cropperMaxHeight"
                [onlyScaleDown]="data.cropOptions.onlyScaleDown"
                [canvasRotation]="canvasRotation"
                [roundCropper]="false"
                [format]="data.outputFormat"
                (imageCropped)="dataImages.box = $event.base64"
            >
            </image-cropper>
        </div>
    </ng-container>

    <ng-container *ngIf="twoStep">
        <div class="flex gap-4 items-center justify-between mb-4">
            <div class="flex-none" *ngIf="twoStep && dataImages.round">
                <img
                    alt="image"
                    class="w-12 h-12 rounded-full border border-solid border-outline-variant"
                    [src]="dataImages.round"
                />
            </div>
            <div class="grow text-sm text-secondary leading-4">
                {{ data.avatarOptions.description }}
            </div>
        </div>

        <div>
            <image-cropper
                [imageBase64]="data.data"
                [resizeToWidth]="data.avatarOptions.resizeToWidth"
                [resizeToHeight]="data.avatarOptions.resizeToHeight"
                [maintainAspectRatio]="true"
                [aspectRatio]="1"
                [onlyScaleDown]="true"
                [roundCropper]="true"
                (imageCropped)="dataImages.round = $event.base64"
            >
            </image-cropper>
        </div>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
    <ng-container *ngIf="data.useAvatarStep">
        <ng-container *ngIf="firstStep">
            <fui-button
                [label]="appService.language_dictionary.files_crop_first_step_submit"
                color="primary"
                height="mini"
                (clickEvent)="switchToSecond()"
            >
            </fui-button>
            <fui-button
                [label]="appService.language_dictionary.files_crop_first_step_cancel"
                color="light"
                height="mini"
                (clickEvent)="close()"
            >
            </fui-button>
        </ng-container>

        <ng-container *ngIf="twoStep">
            <fui-button
                [label]="appService.language_dictionary.files_crop_two_step_submit"
                color="primary"
                height="mini"
                (clickEvent)="save()"
            >
            </fui-button>
            <fui-button
                [label]="appService.language_dictionary.files_crop_two_step_cancel"
                color="light"
                height="mini"
                (clickEvent)="backStep()"
            >
            </fui-button>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!data.useAvatarStep">
        <fui-button
            [label]="appService.language_dictionary.files_crop_two_step_submit"
            color="primary"
            height="mini"
            (clickEvent)="save()"
        >
        </fui-button>
        <fui-button
            [label]="appService.language_dictionary.files_crop_first_step_cancel"
            color="light"
            height="mini"
            (clickEvent)="close()"
        >
        </fui-button>
    </ng-container>
</mat-dialog-actions>
